webpackJsonp([200637785195284],{

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(24);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _axios = __webpack_require__(11);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FaqsEs = function (_Component) {
	  _inherits(FaqsEs, _Component);
	
	  function FaqsEs(props) {
	    _classCallCheck(this, FaqsEs);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      loading: true
	    };
	    _this.handleToogle = _this.handleToogle.bind(_this);
	    _this.renderFaqs = _this.renderFaqs.bind(_this);
	    return _this;
	  }
	
	  FaqsEs.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _axios2.default.get(_config.backendURL + '/api/faqs').then(function (res) {
	      _this2.setState({
	        loading: false,
	        faqs: res.data
	      });
	      _axios2.default.get(_config.backendURL + '/api/banners/page/Faqs').then(function (res) {
	        var main = res.data.filter(function (data) {
	          return data.section === 'Main';
	        });
	        if (main[0]) {
	          _this2.setState(function (prevState) {
	            return _extends({}, prevState, {
	              loading: false,
	              mainImageEs: {
	                title: main[0].title.es,
	                url: main[0].imageEs
	              }
	            });
	          });
	        }
	      }).catch(function (err) {
	        console.log(err);
	      });
	    });
	  };
	
	  FaqsEs.prototype.handleToogle = function handleToogle(e) {
	    var _setState;
	
	    var _e$target = e.target,
	        value = _e$target.checked,
	        id = _e$target.id;
	
	    this.setState((_setState = {}, _setState[id] = value, _setState));
	  };
	
	  FaqsEs.prototype.renderFaqs = function renderFaqs() {
	    var _this3 = this;
	
	    var faqs = this.state.faqs;
	
	    return _.map(faqs, function (faq, i) {
	      var title = faq.title,
	          description = faq.description,
	          published = faq.published;
	      var lang = _this3.props.pathContext.langKey;
	
	      if (published) {
	        var id = 'faq' + i;
	        return _react2.default.createElement(
	          'div',
	          { className: !_this3.state[id] ? 'item on' : 'item off' },
	          _react2.default.createElement('input', { type: 'checkbox', id: id, onClick: _this3.handleToogle }),
	          _react2.default.createElement(
	            'label',
	            { 'for': id },
	            title[lang]
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'excerpt' },
	            description[lang]
	          )
	        );
	        return null;
	      }
	    });
	  };
	
	  FaqsEs.prototype.render = function render() {
	    if (this.state.loading) {
	      return null;
	    }
	    return _react2.default.createElement(
	      'div',
	      { className: 'page faqs' },
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Budget Nicaragua FAQs',
	        meta: [{
	          name: 'description',
	          content: 'Preguntas frecuentes sobre el alquiler de autos.'
	        }],
	        link: [{
	          rel: 'alternate',
	          hreflang: 'es',
	          href: './en/faqs'
	        }]
	      }),
	      this.state.mainImageEs ? _react2.default.createElement('img', {
	        src: '' + _config.backendURL + this.state.mainImageEs.url,
	        alt: this.state.mainImageEs.title,
	        style: { width: '100%' },
	        className: 'top-bg'
	      }) : _react2.default.createElement('div', null),
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'FAQ'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'En Budget Rent a Car estamos siempre a su disposici\xF3n para cualquier duda o consulta que tenga, a continuaci\xF3n algunas preguntas y respuestas o si desea comun\xEDquese con nosotros en el icono de CONTACTENOS para ayudarle personalmente.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'accordion' },
	          this.renderFaqs()
	        )
	      )
	    );
	  };
	
	  return FaqsEs;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = FaqsEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faqs-es-js-46a1b24ae297532de0a4.js